import Devlog from "@/types/Devlog";
import { tenantBoundary } from "./tenant-boundary";
import { raceSafeSplitBilling } from "./race-safe-split-billing";
import { realtimeKitchenSse } from "./realtime-kitchen-sse";
import { deterministicDynamicPricing } from "./deterministic-dynamic-pricing";
import { subscriptionLimitsUnderConcurrency } from "./subscription-limits-under-concurrency";

export const DEVLOGS: Devlog[] = [
    tenantBoundary,
    raceSafeSplitBilling,
    realtimeKitchenSse,
    deterministicDynamicPricing,
    subscriptionLimitsUnderConcurrency,
];
